import { Client } from 'modules/Client/Client'
import { Compartment } from 'modules/Compartment/Compartment'
import { Device } from 'modules/Device/Device'
import { Equipment } from 'modules/Equipment/Equipment'
import { Fluid } from 'modules/Fluid/Fluid'
import { Org } from 'modules/Org/Org'
import { Project } from 'modules/Project/Project'
import { Site } from 'modules/Site/Site'
import { Tank } from 'modules/Tank/Tank'
import { Tenant } from 'modules/Tenant/Tenant'
import { TransactionType } from 'modules/TransactionType/TransactionType'
import { User } from 'modules/User/User'
import { Attr, BelongsTo, Num, Uid } from 'pinia-orm/dist/decorators'
import { Model } from 'pinia-orm'
import { ModelForm } from 'src/packages/orion-pinia-orm/types/ModelForm'
import { LevelNode } from 'modules/LevelNode/LevelNode'

export class Transaction extends Model {
  static override entity = 'transactions'

  @Uid() declare id: string
  @Num(null) declare int_id: number | null

  @Attr(null) declare created_at: string | null
  @Attr(null) declare updated_at: string | null
  @Attr(null) declare deleted_at: string | null

  @Attr(null) declare transaction_number: number | null
  @Attr(null) declare app_transaction_id: string | null
  @Attr(null) declare device_local_number: number | null
  @Attr(null) declare device_number: number | null
  @Attr(null) declare client_id: string | null
  @Attr(null) declare user_number: number | null
  @Attr(null) declare geolocation: string | JSON | null
  @Attr(null) declare longitude: number | null
  @Attr(null) declare latitude: number | null
  @Attr(null) declare location_accuracy: number | null
  @Attr(null) declare equipment_id: string | null
  @Attr(null) declare compartment_id: string | null
  @Attr(null) declare event_datetime: string | null
  @Attr(null) declare pulse_count: number | null
  @Attr(null) declare raw_volume: number | null
  @Attr(null) declare event_k_factor: number | null
  @Attr(null) declare volume_uom: string | null
  @Attr(null) declare termination_state: number | null
  @Attr(null) declare state_auth: string | null
  @Attr(null) declare fluid_name: string | null
  @Attr(null) declare fluid_id: string | null
  @Attr(null) declare odo: number | null
  @Attr(null) declare odo_uom: string | null
  @Attr(null) declare last_odo: number | null
  @Attr(null) declare odo_delta: number | null
  @Attr(null) declare notes_a: string | null
  @Attr(null) declare notes_b: string | null
  @Attr(null) declare compartment_name: string | null
  @Attr(null) declare equipment_name: string | null
  @Attr(null) declare user_name: string | null
  @Attr(null) declare tank_name: string | null
  @Attr(null) declare org_tank_name: string | null
  @Attr(null) declare device_alias: string | null
  @Attr(null) declare device_internal_name: string | null
  @Attr(null) declare site_name: string | null
  @Attr(null) declare project_name: string | null
  @Attr(null) declare client_name: string | null
  @Attr(null) declare transaction_type_name: string | null
  @Attr(null) declare timezone: string | null
  @Attr(null) declare project_id: string | null
  @Attr(null) declare site_id: string | null
  @Attr(null) declare gps_address: string | null
  @Attr(null) declare calculated_level_start: number | null
  @Attr(null) declare calculated_level_end: number | null
  @Attr(null) declare level_sensor_start: number | null
  @Attr(null) declare level_sensor_end: number | null
  @Attr(null) declare level_time_start: string | null
  @Attr(null) declare level_time_end: string | null
  @Attr(null) declare level_delta: number | null
  @Attr(null) declare device_id: string | null
  @Attr(null) declare user_id: string | null
  @Attr(null) declare transaction_type_id: string | null
  @Attr(null) declare mode: string | null
  @Attr(null) declare number_of_seconds_to_complete: number | null
  @Attr(null) declare flow_rate: number | null
  @Attr(null) declare app_version: string | null
  @Attr(null) declare termination_code: string | null
  @Attr(false) declare validated: boolean
  @Attr(null) declare gps_accuracy: string | null
  @Attr(null) declare hardwares_firmware_version: string | null
  @Attr(null) declare meta_data: string
  @Attr(null) declare multiplier: number | null
  @Attr(false) declare archive: boolean
  @Attr(null) declare calendar_view: string | null
  @Attr(null) declare cost_center: string | null
  @Attr(null) declare total_cost: number | null
  @Attr(null) declare cents_per_liter: number | null
  @Attr(null) declare tank_id: string | null
  @Attr(null) declare volume: number | null
  @Attr(null) declare purchase_site: string | null
  @Attr(null) declare asset_number: string | null
  @Attr(null) declare equipment_type: string | null
  @Attr(null) declare this_day_last_yr: number | null
  @Attr(null) declare this_month_vol: number | null
  @Attr(null) declare last_mtd_vol: number | null
  @Attr(null) declare last_month_vol: number | null
  @Attr(null) declare this_qtr_vol: number | null
  @Attr(null) declare last_qtd_vol: number | null
  @Attr(null) declare last_qtr_vol: number | null
  @Attr(null) declare this_year_vol: number | null
  @Attr(null) declare last_year_vol: number | null
  @Attr(null) declare last_ytd_vol: number | null
  @Attr(null) declare project_cost_center: string | null
  @Attr(null) declare equipment_cost_center: string | null
  @Attr(null) declare user_device_user_agent: string | null
  @Attr(null) declare user_device_platform_name: string | null
  @Attr(null) declare user_device_platform: string | null
  @Attr(null) declare level_nodes_raw: ModelForm<LevelNode>[] | null

  @BelongsTo(() => Client, 'client_id') declare client: Client | null
  @BelongsTo(() => Equipment, 'equipment_id') declare equipment: Equipment | null
  @BelongsTo(() => Compartment, 'compartment_id') declare compartment: Compartment | null
  @BelongsTo(() => Fluid, 'fluid_id') declare fluid: Fluid | null
  @BelongsTo(() => Project, 'project_id') declare project: Project | null
  @BelongsTo(() => Site, 'site_id') declare site: Site | null
  @BelongsTo(() => Device, 'device_id') declare device: Device | null
  @BelongsTo(() => TransactionType, 'transaction_type_id') declare transactionType: TransactionType | null
  @BelongsTo(() => Tank, 'tank_id') declare tank: Tank | null
  @BelongsTo(() => User, 'user_id') declare user: User | null

  @Attr(null) declare tenant_id: string
  @Attr(null) declare org_id: number
  @BelongsTo(() => Tenant, 'tenant_id') declare tenant: Tenant | null
  @BelongsTo(() => Org, 'org_id') declare org: Org | null
}
